import { BACKSOLVE } from 'common/constants/allocations';
import type { Cells } from 'common/types/scalarSpreadsheet';
import type { ScenarioData } from 'pages/ValuationsAllocation/allocation/EquityAllocation/config/customAfterCellChanged/types';
import { EQUITY_ALLOCATION_SPREADSHEET_PRESENT_VALUE_PER_SHARE } from 'pages/ValuationsAllocation/common/constants/equityAllocation/sheetAliases';
import type { ApplyScenarioValuesParams } from './types';

const findScenarioCell = (cells: Cells | undefined, scenarioIdOrRef: string) =>
  Object.values(cells ?? {}).find(cell => {
    const data = cell?.data as ScenarioData;
    const reference = data?.scenarioId === 0 ? data?.scenarioRef : data?.scenarioId?.toString();
    return cell?.alias === EQUITY_ALLOCATION_SPREADSHEET_PRESENT_VALUE_PER_SHARE && reference === scenarioIdOrRef;
  });

const applyScenarioValues = ({
  scenario,
  scenarioIdOrRef,
  response,
  cells,
  getCurrentCells,
  onChange,
}: ApplyScenarioValuesParams) => {
  const requestedCells = cells?.equityAllocation ?? (cells && cells[Object.keys(cells)[0]]);
  let cell = findScenarioCell(requestedCells, scenarioIdOrRef);
  if (getCurrentCells) {
    const sheetName = cell?.sheet?.name;
    const currentCell = findScenarioCell(sheetName ? getCurrentCells()?.[sheetName] : undefined, scenarioIdOrRef);
    // A new configuration starts its own calculation; its predecessor must not write model or UI results.
    if (!cell || !currentCell || currentCell.sheet !== cell.sheet) {
      return;
    }
    cell = currentCell;
  }

  const values = scenario.scenario_type === BACKSOLVE ? { ...response, present_values: [] } : response;
  // Keep the accepted result in the model so a later evaluation retains it.
  // eslint-disable-next-line no-param-reassign
  scenario.scenario_values = {
    aggregate_values: values.aggregate_values,
    present_values: values.present_values,
  };
  if (cell && onChange) {
    onChange(cell, values);
  }
};

export default applyScenarioValues;
